<template>
  <div class="appContainer">

    <div v-if="showHeader && !chromeless" id="nav" class="pt-4 pb-4 is-flex is-flex-direction-row">
      <router-link to="/">
        <img alt="Minicity Logo" width="125" class="logo" src="./assets/images/minicity_logo.png"/>
      </router-link>

      <span v-if="STATIC_CONFIG.ENV != Environment.PROD" class="ml-4">{{STATIC_CONFIG.ENV}}</span>

      <div class="is-flex-grow-1"/>

      <button v-if="sessionState.session" class="ctaButton loginButton" @click="logout()">Sign Out</button>
      <router-link v-else to="/login">
        <button class="ctaButton loginButton">Sign In</button>
      </router-link>
    </div>

    <div class="pageWrapper">
      <div class="contentWrapper" :class="{'pt-5': !chromeless}">
        <slot />
      </div>
    </div>

    <div class="is-flex-grow-1"/>
        
    <div v-if="!chromeless" id="footer" class="pt-2 pb-2">
      <span class="pl-2 pr-2">&copy; Mini City, Inc.</span>
      |
      <span class="pl-2 pr-2"><a href="https://www.minicityatl.com/privacypolicy" target="_blank">Privacy Policy</a></span>
    </div>

    <OfferModal
      v-if="displayedModalOffer" :offer="displayedModalOffer" :context="displayedModalContext!"
      @closed="hideModalOffer()"
      style="z-index: 999"/>

  </div>

</template>

<script lang="ts" setup>
import { onMounted } from "vue";
import { endSession, sessionState, chromeless } from "./core/session";
import { loadConfig, STATIC_CONFIG, Environment } from "./core/config";
import { displayedModalOffer, displayedModalContext, hideModalOffer, restoreModalOfferFromQueryParams } from '@/features/partnerOffers/state';

import OfferModal from '@/features/partnerOffers/OfferModal.vue';
import { useRoute, useRouter } from "vue-router";

const props = defineProps<{
  showHeader?: boolean,
  login?: 'require'|'disallow'
}>();

const router = useRouter();
const route = useRoute();

onMounted(async () => {
  await router.isReady();

  if (!sessionState.session && !route.query.sessionId) {
    const isSessionAvailableToResume = Boolean(localStorage["session"]);
    const shouldLogin = props.login == 'require' || (props.login != 'disallow' && isSessionAvailableToResume);
  
    if (shouldLogin) {
      router.push(`/login?forwardTo=${encodeURIComponent(document.location.pathname + document.location.search)}`);
      return;
    }
  }

  loadConfig();

  restoreModalOfferFromQueryParams();
});

const logout = () => {
  endSession();
  router.push("/login");
}
</script>

<style lang="scss" scoped>
@import "./assets/variables.scss";

.appContainer {
  height: 100%;
  display: flex;
  flex-direction: column;
}

#nav {
  align-items: center;
  padding-left: 2rem;
  padding-right: 2rem;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.logo {
  vertical-align: middle;
}

#footer {
  text-align: center;
  font-weight: bold;
  background-color: #EDEDED;
}

.loginButton {
  background-color: $primaryDark;
}

</style>
